import i18n from '../../../i18n';
import { formatAddress, formatBsnWithLeadingZero, formatBsnRemoveLeadingZero, arraySortAscendingFunction } from '../../../services/utilities';

export const createStufBgQueryObject = (addressdata) => {

    // Mapping from fields in addressdata to fields in endpoint GetNaturalPersons
    const queryFields = {
        Bsn: 'bsn',
        Geslachtsnaam: 'geslachtsNaam',
        VoorvoegselGeslachtsnaam: 'voorvoegselGeslachtsnaam',
        Voorletters: 'voorletters',
        Geslachtsaanduiding: 'geslachtsAanduiding',
        BurgerlijkeStaat: 'burgerlijkeStaat',
        GeboorteDatum: 'geboorteDatum',
        Geboorteplaats: 'geboortePlaats',
        GeboorteLand: 'geboorteLand',
        Overlijdensdatum: 'overlijdensDatum',
        Overlijdenplaats: 'overlijdenPlaats',
        OverlijdenLand: 'overlijdenLand',
        city: 'wplWoonplaatsNaam',
        streetName: 'gorStraatnaam',
        huisNummer: 'aoaHuisnummer',
        huisLetter: 'aoaHuisletter',
        huisNummerToevoeging: 'aoaHuisnummertoevoeging',
        postCode: 'aoaPostcode'
    };
    let query = {};
    // Only add fields that have a value (null is also a value)
    for (let key in queryFields) {
        if (typeof addressdata[key] !== 'undefined' && addressdata[key]) {
            if (key === 'Bsn') {
                query[queryFields[key]] = formatBsnWithLeadingZero(addressdata[key]);
            } else {
                query[queryFields[key]] = addressdata[key].toString();
            }
        }
    }
    return query;
};

export const getNaturalPersons = (personsJson, userIsBrkAuthorized) => {

    const formatDate = (datum) => {
        if (datum) {
            return `${datum.substring(6, 8)}-${datum.substring(
                4,
                6
            )}-${datum.substring(0, 4)}`;
        } else {
            return '';
        }
    };

    const getAddressObject = (data, adres) => {
        return {
            straatnaam: data[`${adres}Straatnaam`],
            huisnummer: data[`${adres}Huisnummer`],
            huisletter: data[`${adres}Huisletter`],
            huisnummerToevoeging: data[`${adres}Huisnummertoevoeging`],
            postcode: data[`${adres}Postcode`],
            plaats: data[`${adres}Woonplaats`],
        };
    };

    let items = [];
    let fields = [];

    let verblijftInWoonplaats;
    let verblijftInStraatnaam;
    let verblijftInPostcode;
    let verblijftInHuisnummer;
    let verblijftInHuisletter;
    let verblijftInHuisnummertoevoeging;

    for (let i = 0, l = personsJson.length; i < l; i++) {
        if (personsJson[i].inpverblijftIn?.gerelateerde?.adresAanduidingGrp) {
            verblijftInWoonplaats = personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.wplwoonplaatsNaam.value;
            verblijftInStraatnaam = personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.gorstraatnaam.value ||
                personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.goropenbareRuimteNaam.value;
            verblijftInPostcode = personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.aoapostcode.value;
            verblijftInHuisnummer = personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.aoahuisnummer.value;
            verblijftInHuisletter = personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.aoahuisletter.value;
            verblijftInHuisnummertoevoeging = personsJson[i].inpverblijftIn.gerelateerde.adresAanduidingGrp.aoahuisnummertoevoeging.value;
        } else {
            verblijftInWoonplaats = null;
            verblijftInStraatnaam = null;
            verblijftInPostcode = null;
            verblijftInHuisnummer = null;
            verblijftInHuisletter = null;
            verblijftInHuisnummertoevoeging = null;
        }

        items.push({
            id: i,
            nedGlobeRowId: i, // provide a unique ID column to avoid conflicts with the ID column in the data
            BSN: formatBsnRemoveLeadingZero(personsJson[i].inpbsn.value),
            Geslachtsnaam: personsJson[i].geslachtsnaam.value,
            Voorvoegsel: personsJson[i].voorvoegselGeslachtsnaam.value,
            Voorletters: personsJson[i].voorletters.value,
            Geslachtsaanduiding: personsJson[i].geslachtsaanduiding.value,
            BurgerlijkeStaat: personsJson[i].inpburgerlijkeStaat.value,
            Geboortedatum: formatDate(
                personsJson[i].geboortedatum.value
            ),
            Geboorteplaats: personsJson[i].inpgeboorteplaats.value,
            Geboorteland: personsJson[i].inpgeboorteLand.value,
            Overlijdensdatum: formatDate(
                personsJson[i].overlijdensdatum.value
            ),
            Overlijdenplaats: personsJson[i].inpoverlijdenplaats.value,
            Overlijdenland: personsJson[i].inpoverlijdenLand.value,
            VerblijftInWoonplaats: verblijftInWoonplaats,
            VerblijftInStraatnaam: verblijftInStraatnaam,
            VerblijftInPostcode: verblijftInPostcode,
            VerblijftInHuisnummer: verblijftInHuisnummer,
            VerblijftInHuisletter: verblijftInHuisletter,
            VerblijftInHuisnummertoevoeging: verblijftInHuisnummertoevoeging,
            VerblijfsAdresWoonplaats: personsJson[i].verblijfsadres?.wplwoonplaatsNaam?.value,
            VerblijfsAdresStraatnaam:
                personsJson[i].verblijfsadres?.gorstraatnaam?.value ||
                personsJson[i].verblijfsadres?.goropenbareRuimteNaam.value,
            VerblijfsAdresPostcode: personsJson[i].verblijfsadres?.aoapostcode?.value,
            VerblijfsAdresHuisnummer: personsJson[i].verblijfsadres?.aoahuisnummer?.value,
            VerblijfsAdresHuisletter: personsJson[i].verblijfsadres?.aoahuisletter?.value,
            VerblijfsAdresHuisnummertoevoeging: personsJson[i].verblijfsadres?.aoahuisnummertoevoeging?.value,
            CorrespondentieAdresWoonplaats: personsJson[i].subcorrespondentieAdres?.wplwoonplaatsNaam?.value,
            CorrespondentieAdresStraatnaam:
                personsJson[i].subcorrespondentieAdres?.gorstraatnaam?.value ||
                personsJson[i].subcorrespondentieAdres?.goropenbareRuimteNaam?.value,
            CorrespondentieAdresPostcode: personsJson[i].subcorrespondentieAdres?.aoapostcode?.value,
            CorrespondentieAdresHuisnummer: personsJson[i].subcorrespondentieAdres?.aoahuisnummer?.value,
            CorrespondentieAdresHuisletter: personsJson[i].subcorrespondentieAdres?.aoahuisletter?.value,
            CorrespondentieAdresHuisnummertoevoeging: personsJson[i].subcorrespondentieAdres?.aoahuisnummertoevoeging?.value,
            GeslachtsnaamPartner: personsJson[i].geslachtsnaamPartner?.value,
            VoorvoegselGeslachtsnaamPartner: personsJson[i].voorvoegselGeslachtsnaamPartner?.value
        });
    }

    if (items.length > 0) {
        fields.push(
            {
                key: 'Geslachtsnaam',
                label: i18n.t('stuf.geslachtsnaam'),
                sortable: true
            },
            {
                key: 'Voorletters',
                label: i18n.t('stuf.voorlettersAbbr'),
                sortable: true
            },
            {
                key: 'Voorvoegsel',
                label: i18n.t('stuf.voorvoegselAbbr'),
                sortable: true
            },
            {
                key: 'BSN',
                label: i18n.t('stuf.bsn'),
                sortable: true
            },
            {
                key: 'Geboortedatum',
                label: i18n.t('stuf.geboortedatum'),
                sortable: true
            },
            {
                key: 'Geslachtsaanduiding',
                label: i18n.t('stuf.geslachtsaanduiding'),
                sortable: true
            },
            {
                key: 'Geboorteplaats',
                label: i18n.t('stuf.geboorteplaats'),
                sortable: true
            },
            {
                key: 'Geboorteland',
                label: i18n.t('stuf.geboorteland'),
                sortable: true
            },
            {
                key: 'BurgerlijkeStaat',
                label: i18n.t('stuf.burgerlijkeStaat'),
                sortable: true
            },
            {
                key: 'VerblijftIn',
                label: i18n.t('stuf.verblijftin'),
                sortable: true
            },
            {
                key: 'VerblijfsAdres',
                label: i18n.t('stuf.verblijfsadres'),
                sortable: true
            },
            {
                key: 'CorrespondentieAdres',
                label: i18n.t('stuf.correspondentieadres'),
                sortable: true
            },
            {
                key: 'Overlijdensdatum',
                label: i18n.t('stuf.overlijdensdatum'),
                sortable: true
            },
            {
                key: 'Overlijdenplaats',
                label: i18n.t('stuf.overlijdenplaats'),
                sortable: true
            },
            {
                key: 'Overlijdenland',
                label: i18n.t('stuf.overlijdenland'),
                sortable: true
            }
        );
    }


    items.forEach(item => {
        item.VerblijfsAdres = formatAddress(getAddressObject(item, 'VerblijfsAdres'));
        item.CorrespondentieAdres = formatAddress(getAddressObject(item, 'CorrespondentieAdres'));
        item.VerblijftIn = formatAddress(getAddressObject(item, 'VerblijftIn'));
    });


    let relation = {};

    // Only show link to cadastral properties if user has BRK authorization.
    // otherwise a runtime error occurs.
    if (userIsBrkAuthorized) {
        relation = {
            name: i18n.t('brk.cadastralProperties'),
            title: `${String(i18n.t('relations.showRelated'))} ${String(i18n.t('cadastralInformationTitle')).toLowerCase()}`,
            type: 'link',
            action: 'getKadastraalOnroerendeZaken'
        };
    }


    // sort items
    items.sort(arraySortAscendingFunction('Geslachtsnaam'));

    return {
        items,
        fields,
        sortBy: 'Geslachtsnaam',
        selectable: true,
        relation: relation,
        rowClick: { action: 'highlightNatPersons' }
    };
};
